import { createStore } from '@stencil/store';

import { AfterMarket } from '../interfaces/interface.aftermarket';

// Afermarket Conditions (Modifications)
const initialState: AfterMarket = {
  exhaustQuestions: [],
  userInteraction: {
    twokeys: false,
    mods: false,
    stereo: false,
    wheelstires: false,
    suspension: false,
    performance: false,
    exhaust: false,
  },
  performanceQuestions: [],
  questionsAftermarket: [],
  stereoQuestions: [],
  subsectionOrder: ['Stereo', 'Wheels & Tires', 'Suspension', 'Performance Modifications'],
  suspensionQuestions: [],
  twoKeysQuestions: [], // manually added to display two keys question
  wheelsTiresQuestions: [],
  toggleModificationsQuestion: [], // manually added to toggle modifications questions,
  showModificationsQuestionGroup: false,
  showModificationsQuestion: false,
  showModificationRemovalPrompt: false,
};

const { state, on, onChange, reset } = createStore(initialState);

export { on, onChange, state, reset };
export default state;
